import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll the element matching the current URL hash into view. `BrowserRouter`
 * does no scroll restoration, so in-page section links (`/#about`) navigated to
 * as real router `<Link>`s won't scroll on their own — this handles both
 * arriving on the route with a hash and changing the hash while already on it.
 * Honors `prefers-reduced-motion`, matching the site's other animations.
 */
export function useScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (!el) return;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  }, [hash]);
}
